<template>
    <span v-if="!fieldValid">
        {{
        $t('errors.Between', { f: $t(fieldName), min: fieldMin, max: fieldMax })
        }}
    </span>
</template>
<script>
  export default {
      components: {},

      props: {
          fieldName: { required: true },
          fieldValid: { required: true },
          fieldMin: { required: true },
          fieldMax: { required: true },
      },
  };
</script>
<style scoped>
  span {
      text-align: center;
  }
</style>
